import { render, staticRenderFns } from "./CountryDelete.vue?vue&type=template&id=72fefaee&"
import script from "./CountryDelete.vue?vue&type=script&lang=js&"
export * from "./CountryDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports